module.exports = __webpack_public_path__ + "static/media/bonusSpins_15_20.d31a6be2.png";